import { render, staticRenderFns } from "./bindHotel.vue?vue&type=template&id=2a7bae4a&scoped=true"
import script from "./bindHotel.vue?vue&type=script&lang=js"
export * from "./bindHotel.vue?vue&type=script&lang=js"
import style0 from "./bindHotel.vue?vue&type=style&index=0&id=2a7bae4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7bae4a",
  null
  
)

export default component.exports